import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import {
    HUB_REGISTRATION_FORM_CONFIGURATION_URL,
    HUB_CUSTOM_FIELD_DELETE_URL,
} from '../../constants/api/hub-registration-configuration.constants';
import {
    IHubRegistrationConfigurationDAO,
    IHubRegistrationFormDTO,
} from '../hub-registration-configuration.dao';

class HubRegistrationConfigurationDAO extends IHubRegistrationConfigurationDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getRegistrationFormConfiguration(
        accountId: number,
        eventHubId: number
    ): Promise<IHubRegistrationFormDTO> {
        const response = await this.apiClient.get<IHubRegistrationFormDTO>(
            HUB_REGISTRATION_FORM_CONFIGURATION_URL,
            { accountId: accountId, eventHubId: eventHubId }
        );

        return response.parsedResponse;
    }

    public async updateRegistrationFormConfiguration(
        accountId: number,
        eventHubId: number,
        configuration: IHubRegistrationFormDTO
    ): Promise<IHubRegistrationFormDTO> {
        const response = await this.apiClient.put<IHubRegistrationFormDTO>(
            HUB_REGISTRATION_FORM_CONFIGURATION_URL,
            { accountId: accountId, eventHubId: eventHubId, ...configuration }
        );

        return response.parsedResponse;
    }

    public async deleteCustomField(
        accountId: number,
        eventHubId: number,
        customFieldId: number
    ): Promise<void> {
        await this.apiClient.delete(HUB_CUSTOM_FIELD_DELETE_URL, {
            accountId: accountId,
            eventHubId: eventHubId,
            customFieldId: customFieldId,
        });
    }
}

export { HubRegistrationConfigurationDAO };
